import { $WC } from "@/conf/common.const.js";
import commonApi from "@/api/common.api.js";

export default {
    state: {
        naverMaps: undefined,
        geoJsonDrawing: undefined,
        markerMap: {},
        selectedMarker: {},
        curInfoWindow: undefined,
        addongList: undefined,
        polylineMap: {},
        circleMap: {},
    },
    getters: {
        getNaverMaps(state) {
            return state.naverMaps;
        },
        getGeoJsonDrawing(state) {
            return state.geoJsonDrawing;
        },
        getMarkerMap(state) {
            return state.markerMap;
        },
        getSelectedMarker(state) {
            return state.selectedMarker;
        },
        getCurInfoWindow(state) {
            return state.curInfoWindow;
        },
        getAddongList(state) {
            return state.addongList;
        },
        getPolylineMap(state) {
            return state.polylineMap;
        },
        getCircleMap(state) {
            return state.circleMap;
        },
    },
    mutations: {
        NAVER_MAPS(state, naverMaps) {
            state.naverMaps = naverMaps;
        },
        GEO_JSON_DRAWING(state, geoJsonDrawing) {
            state.geoJsonDrawing = geoJsonDrawing;
        },
        MARKER_MAP(state, markerMap) {
            state.markerMap = markerMap;
        },
        SELECTED_MARKER(state, selectedMarker) {
            state.selectedMarker = selectedMarker;
        },
        CUR_INFO_WINDOW(state, curInfoWindow) {
            state.curInfoWindow = curInfoWindow;
        },
        ADDONG_LIST(state, addongList) {
            state.addongList = addongList;
        },
        POLYLINE_MAP(state, polylineMap) {
            state.polylineMap = polylineMap;
        },
        CIRCLE_MAP(state, circleMap) {
            state.circleMap = circleMap;
        },
    },
    actions: {
        SET_NAVER_MAPS({commit}, naverMaps) {
            commit("NAVER_MAPS", naverMaps);
        },
        SET_GEO_JSON_DRAWING({commit}, geoJsonDrawing) {
            commit("GEO_JSON_DRAWING", geoJsonDrawing);
        },
        SET_MARKER_MAP({commit}, markerMap) {
            commit("MARKER_MAP", markerMap);
        },
        SET_SELECTED_MARKER({commit}, selectedMarker) {
            commit("SELECTED_MARKER", selectedMarker);
        },
        SET_CUR_INFO_WINDOW({commit}, curInfoWindow) {
            commit("CUR_INFO_WINDOW", curInfoWindow);
        },
        SET_ADDONG_LIST({commit}, addongList) {
            commit("ADDONG_LIST", addongList);
        },
        FETCH_ADDONG_LIST({commit}) {
            return commonApi.fetchSubAddongList($WC.adGuCode)
                .then(res => {
                    // 가나다순 정렬
                    res.data.sort((pre, cur) => {
                        return pre.kostatAddongKorNm < cur.kostatAddongKorNm ? -1 : pre.kostatAddongKorNm > cur.kostatAddongKorNm ? 1: 0;
                    });
                    commit("ADDONG_LIST", res.data);
                });
        },
        SET_POLYLINE_MAP({commit}, polylineMap) {
            commit("POLYLINE_MAP", polylineMap);
        },
        SET_CIRCLE_MAP({commit}, circleMap) {
            commit("CIRCLE_MAP", circleMap);
        },
    }
};
